<div class="container-screen">
  <div *ngIf="authService.isAuthenticated()">
    <app-navbar
      *ngIf="specialNavbarType == null && showRegularNavbar"
    ></app-navbar>
    <placer-navbar *ngIf="specialNavbarType === PLACER_NAVBAR"></placer-navbar>
    <atelier-navbar
      *ngIf="specialNavbarType === ATELIER_NAVBAR"
    ></atelier-navbar>
  </div>
  <div class="container-fluid">
    <mat-card
      class="info-panel"
      *ngIf="authService.isAuthenticated() && userHasAccessToNewPortal"
    >
      <mat-card-content>
        <mat-icon>info</mat-icon>Het nieuwe klantenportaal is beschikbaar -
        ontdek het
        <a (click)="goToNewPortal()" href="#">hier</a></mat-card-content
      >
    </mat-card>
    <router-outlet></router-outlet>
    <div *ngIf="authService.isAuthenticated()">
      <tab-content></tab-content>
    </div>
  </div>
</div>
